// 启动事件
SR.App.on('onLaunch', function() {
    var deviceInfo = SR.data.deviceInfo;
    var SDKInfo = SR.data.SDKInfo;
    var userInfo = SR.data.userInfo;
    var themeInfo = {
        theme: 'dark'
    };
    var count = 3;
    SR.state.isDebug = location.href.indexOf('debug=1') !== -1;

    function done() {
        if (count > 1) {
            count -= 1;
            return;
        }
        SR.App.trigger('onLaunched');
    }

    // 获取 SDK 版本号
    SDKInfo.callback = function(code, param) {
        var SDKParams = JSON.parse(param);
        SDKInfo.version = SDKParams.ret;
        done();
    };
    // 获取设备
    deviceInfo.callback = function(code, param) {
        var deviceParams = JSON.parse(param);
        deviceInfo.guid = deviceParams.guid;
        deviceInfo.xua = deviceParams.xua;
        done();
    };
    // 获取用户信息
    userInfo.callback = function(code, param) {
        var userParams = JSON.parse(param);
        userInfo.uid = userParams.uid;
        if (userParams.avatar) {
            userInfo.userAvatar = userParams.avatar;
        }
        done();
    };
    // 主题信息
    themeInfo.callback = function(code, param) {
        var themeInfoParams = JSON.parse(param);
        if (themeInfoParams.ret === 1) {
            // 橙色版
            SDKInfo.theme = 'dark';
        } else if (themeInfoParams.ret === 2) {
            // 白色版
            SDKInfo.theme = 'light';
        }
    };

    if (SR.state.isNative && !SR.state.isDebug) {
        upNativeComm.exec('App.getVersion', SDKInfo);
        upNativeComm.exec('smartRobot.srGetUserInfo', deviceInfo);
        upNativeComm.exec('UPUser.getUserInfo', userInfo);
        upNativeComm.exec('WebView.getThemeType', themeInfo);
    }

    // 设置 root 字号
    function setRootFontSize() {
        if (SR.state.isSmartRobot) {
            // window.innerWidth 在 iOS 中会出现超大数值现象
            var fontSize = document.documentElement.clientWidth / 10 + 'px';
            document.documentElement.style.fontSize = fontSize;
            SR.data.rootFontSize = fontSize;
        }
    }
    window.addEventListener('resize', setRootFontSize);
    setRootFontSize();
});